import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import t, { mixin } from "theme"
import selectArrow from "../../../content/assets/selectarrow.svg"
import { Link } from "gatsby"

//if no width given, apply default padding between the text and the angledown. If width given, have it be a flexbox.
//should be able to take either a list of companies or list of features

const DropdownMenu = ({ selected, choices, backup, ...props }) => (
    <div
        css={css`
            display: flex;
            height: 100%;
            overflow-y: visible;
        `}
        {...props}>
        <ShownItem>
            <div
                css={css`
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: calc(${t.space[10]} * 1.5);
                    ${mixin.phonestyle} {
                        width: ${selected ? "35vw" : "90vw"};
                    }
                `}>
                {backup ? (
                    backup
                ) : (
                    <div>{choices.find(el => el.id.toLowerCase() === selected.toLowerCase()).label}</div>
                )}
                <img
                    src={selectArrow}
                    css={css`
                        ${mixin.phonestyle} {
                            padding-right: 0;
                        }
                    `}
                    alt="select"
                />
            </div>
            <HiddenItem>
                {choices.map((choice, index) => (
                    <Link to={choice.pathname}>
                        <div
                            css={css`
                                padding: ${t.space[2]} ${t.space[3]};
                                width: calc(1.7 * ${t.space[10]} + 0.5 * (${t.space[5]} + ${t.space[3]}));
                                ${mixin.tabletandphonestyle} {
                                    width: 40vw;
                                }
                                background-color: ${selected && selected.toLowerCase() === choice.id.toLowerCase()
                                    ? t.color.light
                                    : t.color.white};
                                :hover {
                                    color: ${t.color.primary};
                                }
                            `}>
                            {choice.label}
                        </div>
                    </Link>
                ))}
            </HiddenItem>
        </ShownItem>
    </div>
)

export default DropdownMenu

const HiddenItem = styled.div`
    position: absolute;
    visibility: hidden;
    z-index: 2000;
    left: -${t.space[3]};
    top: 100%;
    box-shadow: 0 0.3rem 0.6rem 0 ${t.color.subtlegrey};
    background-color: white;
    transform: translateY(-2rem);
    opacity: 0;
    transition: all 0.2s ease-in-out 0s, visibility 0s linear 0.2s;
`

const ShownItem = styled.div`
    position: relative;
    display: flex;
    height: 100%;

    :hover ${HiddenItem} {
        visibility: visible;
        opacity: 1;
        transform: translateY(0%);
        transition-delay: 0s, 0s, 0.2s;
    }
`
//https://codepen.io/shshaw/pen/gsFch
